import React from 'react';

export const useFiltering = (dataList, category) => {
  return dataList.filter((data) => data.category === `${category}`);
};
